export default __webpack_public_path__ + "static/media/\bc_contract.d404ced3.avif";